module.exports = __webpack_public_path__ + "static/media/productos_botanas_cacahuate_holandes.728485d5.png";